import { render } from "./FuelConsult.vue?vue&type=template&id=4a38931e&scoped=true"
import script from "./FuelConsult.vue?vue&type=script&lang=js"
export * from "./FuelConsult.vue?vue&type=script&lang=js"

import "./FuelConsult.vue?vue&type=style&index=0&id=4a38931e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a38931e"]])

export default __exports__